module.exports = {
  title: 'Paysharp',
};
